import * as swcHelpers from '@swc/helpers';
import { FormControl } from '../../FormControl/FormControl.js';
import { isValidBirthDateYear, isValidMonth, isValidDay } from '../../Util/validations.js';

const getFieldValues = (name, fields)=>{
    var ref, ref1, ref2;
    var ref3;
    const day = (ref3 = fields === null || fields === void 0 ? void 0 : (ref = fields[`${name}Day`]) === null || ref === void 0 ? void 0 : ref.value) !== null && ref3 !== void 0 ? ref3 : '';
    var ref4;
    const month = (ref4 = fields === null || fields === void 0 ? void 0 : (ref1 = fields[`${name}Month`]) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref4 !== void 0 ? ref4 : '';
    var ref5;
    const year = (ref5 = fields === null || fields === void 0 ? void 0 : (ref2 = fields[`${name}Year`]) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref5 !== void 0 ? ref5 : '';
    return {
        day,
        month,
        year
    };
};
const isEqualState = (a, b)=>a.value === b.value && a.isTouched === b.isTouched && a.isValid === b.isValid && a.readonly === b.readonly
;
const updateFields = (name, fields = {}, nextState = {})=>{
    if (Object.keys(fields).length === 0) {
        return {};
    }
    const currentField = swcHelpers.objectSpread({
        value: ''
    }, fields[name], nextState, {
        name
    });
    return swcHelpers.objectSpread({}, fields, {
        [name]: currentField
    });
};
const getFieldNames = (name)=>({
        day: `${name}Day`,
        month: `${name}Month`,
        year: `${name}Year`
    })
;
const joinValues = (name, fields)=>{
    var ref;
    const { day , month , year  } = (ref = getFieldValues(name, fields)) !== null && ref !== void 0 ? ref : {};
    const formattedDay = day && day !== '00' ? day === null || day === void 0 ? void 0 : day.padStart(2, '0') : '';
    const formattedMonth = month && month !== '00' ? month === null || month === void 0 ? void 0 : month.padStart(2, '0') : '';
    return `${year}-${formattedMonth}-${formattedDay}`;
};
const initializeFields = ({ name , value ='' , isTouched =false , required =false  })=>{
    const isShortDate = value.includes('-');
    const isLongDate = value.includes('T') && isShortDate;
    let date = [];
    if (isLongDate) {
        var ref;
        var ref6;
        date = (ref6 = (ref = value.split('T')[0]) === null || ref === void 0 ? void 0 : ref.split('-')) !== null && ref6 !== void 0 ? ref6 : [];
    } else if (isShortDate) {
        date = value.split('-');
    }
    var ref7;
    const day = {
        name: `${name}Day`,
        value: (ref7 = date[2]) !== null && ref7 !== void 0 ? ref7 : ''
    };
    var ref8;
    const month = {
        name: `${name}Month`,
        value: (ref8 = date[1]) !== null && ref8 !== void 0 ? ref8 : ''
    };
    var ref9;
    const year = {
        name: `${name}Year`,
        value: (ref9 = date[0]) !== null && ref9 !== void 0 ? ref9 : ''
    };
    return {
        [year.name]: {
            name: year.name,
            value: year.value,
            isTouched: isTouched || !!year.value,
            isValid: validateWithRequired(year.value, isValidBirthDateYear, {
                required
            })
        },
        [month.name]: {
            name: month.name,
            value: month.value,
            isTouched: isTouched || !!month.value,
            isValid: validateWithRequired(month.value, isValidMonth, {
                required
            })
        },
        [day.name]: {
            name: day.name,
            value: day.value,
            isTouched: isTouched || !!day.value,
            isValid: validateWithRequired(day.value, isValidDay, {
                required
            })
        }
    };
};
const validateFullDate = (name, fields, required, validation)=>{
    if (!fields) {
        return false;
    }
    var ref;
    const { day , month , year  } = (ref = getFieldValues(name, fields)) !== null && ref !== void 0 ? ref : {};
    // Field is valid when it's not required and not all of the fields have values
    if (!required && (day === '' || month === '' || year === '')) {
        return true;
    }
    if ([
        day,
        month
    ].some((item)=>{
        return (item === null || item === void 0 ? void 0 : item.length) && (item === null || item === void 0 ? void 0 : item.length) > 2;
    })) {
        return false;
    }
    const value1 = [
        year,
        month,
        day
    ].filter((value)=>!!value
    ).join('-');
    const { isValid  } = FormControl.validate([
        validation
    ], [], required, value1);
    return !validation || isValid;
};
const focusElementWhenValueReady = (value, ref)=>{
    var ref10;
    return value.length === 2 ? (ref10 = ref.current) === null || ref10 === void 0 ? void 0 : ref10.focus() : undefined;
};
const getErrorMessageBasedOnValidation = (validationResults, errorMessages = [])=>{
    const indexOfFirstFailedValidation = validationResults.lastIndexOf(false);
    if (indexOfFirstFailedValidation === -1) {
        return '';
    }
    var _indexOfFirstFailedValidation;
    return (_indexOfFirstFailedValidation = errorMessages[indexOfFirstFailedValidation]) !== null && _indexOfFirstFailedValidation !== void 0 ? _indexOfFirstFailedValidation : 'Unknown error';
};
const validateWithRequired = (value, validator, options)=>{
    if (!(options === null || options === void 0 ? void 0 : options.required)) {
        return !value ? true : validator(value);
    }
    return validator(value);
};

export { focusElementWhenValueReady, getErrorMessageBasedOnValidation, getFieldNames, initializeFields, isEqualState, joinValues, updateFields, validateFullDate, validateWithRequired };
//# sourceMappingURL=utils.js.map
